// autopilot-capabilities-command.ts
//
// V2 spec §7: `avatar autopilot capabilities --json` — the capability probe
// startbuild runs at step 1. A subcommand of `autopilot` (registered from
// autopilot.ts; build-avatar-command-registry.ts untouched, v1 §21). Reads no
// mission state, no config, no credentials. A CLI without this command (v1)
// fails the probe ⇒ the pack treats every flag as `false` (v1 path).
import type { Command } from "commander";
import { AUTOPILOT_CLI_CAPABILITIES } from "../lib/autopilot/autopilot-cli-capabilities.js";
import { writeMachineReadableJson } from "../lib/machine-readable-json-output-contract.js";
import { log } from "../lib/terminal-logger.js";

export function registerAutopilotCapabilitiesCommand(autopilot: Command): void {
  autopilot
    .command("capabilities")
    .description(
      "Liệt kê tính năng autopilot V2 mà CLI này hỗ trợ (pack probe theo cờ, không theo version)",
    )
    .option("--json", "Output JSON cho máy đọc")
    .action((opts: { json?: boolean }) => {
      if (opts.json) {
        writeMachineReadableJson({
          command: "autopilot capabilities",
          ...AUTOPILOT_CLI_CAPABILITIES,
        });
        return;
      }
      for (const [name, on] of Object.entries(AUTOPILOT_CLI_CAPABILITIES)) {
        log.info(`${name}: ${on ? "có" : "chưa"}`);
      }
    });
}
